<template>
  <div id="page-chat-list" class="vx-card p-6">
    <template>
      <vx-card
        v-show="hasChatSetting"
        ref="filterCard"
        class="user-list-filters mb-8"
        actionButtons
        @refresh="resetColFilters"
        @remove="resetColFilters"
      >
        <template v-slot:customActions>
          <span @click="chatLogout" class="cursor-pointer">ログアウト</span>
        </template>
        <div class="vx-row">
          <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
            <label class="text-sm opacity-75">メールアドレス</label>
            <vs-input
              class="sm:mr-4 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
              placeholder="メールアドレス"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
              v-model="filterChats.email"
              icon-after="true" :icon="filterChats.email ? iconVsInput : ''"
            />
          </div>
          <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
            <label class="text-sm opacity-75">契約ｱﾌﾟﾘｹｰｼｮﾝ</label>
            <v-select
              class="sm:mr-4 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
              label="value"
              :searchable="false"
              :reduce="(item) => item.key"
              :options="contractApps"
              v-model="filterChats.contract_app"
            >
            </v-select>
          </div>
          <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
            <label class="text-sm opacity-75">契約サーバー</label>
            <v-select
              class="sm:mr-4 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
              label="value"
              :searchable="false"
              :reduce="(item) => item.key"
              :options="contractServers"
              v-model="filterChats.contract_server"
            >
            </v-select>
          </div>
          <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
            <label class="text-sm opacity-75">所属企業</label>
            <vs-input
              class="sm:mr-4 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
              placeholder="所属企業（部分一致）"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
              v-model="filterChats.company"
              icon-after="true" :icon="filterChats.company ? iconVsInput : ''"
            />
          </div>
        </div>
        <div class="vx-row mt-4">
          <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
            <label class="text-sm opacity-75">ユーザ名</label>
            <vs-input
              class="sm:mr-4 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
              placeholder="ユーザ名（部分一致）"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
              v-model="filterChats.user_name"
              icon-after="true" :icon="filterChats.user_name ? iconVsInput : ''"
            />
          </div>
          <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
            <label class="text-sm opacity-75">契約環境</label>
            <v-select
              class="sm:mr-4 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
              label="value"
              :searchable="false"
              :reduce="(item) => item.key"
              :options="appEnvs"
              v-model="filterChats.app_env"
            >
            </v-select>
          </div>
          <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
            <label class="text-sm opacity-75">カテゴリ</label>
            <v-select
              class="sm:mr-4 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
              label="value"
              :searchable="false"
              :reduce="(item) => item.key"
              :options="categoryStateOptions"
              v-model="filterChats.category_id"
            >
            </v-select>
          </div>
          <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
            <label class="text-sm opacity-75">&nbsp;</label>
            <vs-checkbox
              v-model="filterChats.is_new"
              vs-value="is_new"
              class="chk-is-new"
              >NEWのみ表示</vs-checkbox
            >
          </div>
        </div>
        <div class="vx-row mt-4">
          <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
            <label class="text-sm opacity-75">状態</label>
            <v-select
              class="sm:mr-4 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
              label="text"
              :searchable="false"
              :reduce="(item) => item.value"
              :options="faqStateOptions"
              v-model="filterChats.state"
            >
            </v-select>
          </div>
          <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
            <label class="text-sm opacity-75">担当者</label>
            <v-select
              class="sm:mr-4 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
              label="name"
              :searchable="false"
              :reduce="(item) => item.id"
              :options="chargeAdminOptions"
              v-model="filterChats.charge_admin_id"
            >
            </v-select>
          </div>
        </div>
        <div class="vx-row">
          <div
            class="vx-col md:w-1/5 sm:w-1/2 w-full flex flex-wrap items-end justify-end div-search-bnt"
          >
            <vs-button
              icon="search"
              @click="
                pageNumber = 1;
                searchWithOrder();
                ids = [];
              "
              class="search_icon mr-6 sm:mr-3"
              >検索
            </vs-button>
          </div>
        </div>
      </vx-card>
      <conversation
        :popup-active="conversationPopup"
        @sent="sentEvent = true"
        @deleteFaqBbsNewIcon="deleteFaqBbsNewIcon"
        :faq-selected-item="selectedItem"
        @onClose="onCloseConversationPopup"
      />
      <!-- AgGrid Table -->
      <div v-show="hasChatSetting" class="chat-list">
        <vs-row class="pl-2">
          <vs-col
            class="flex flex-wrap items-center justify-start pl-6"
            vs-w="6"
          >
            <span class="pr-2">表示件数:</span>
            <div class="vx-col md:w-24 w-full">
              <v-select
                class="sm:mr-4 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
                :options="paginationOptions"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                v-model="paginationPageSize"
              >
                <span slot="no-options" class="text-xs"
                  >すみません、マッチングオプションがありません。</span
                >
              </v-select>
            </div>
          </vs-col>
        </vs-row>
        <ag-grid-vue
          id="faq-bbs-list"
          ref="agGridTable"
          :components="components"
          :gridOptions="gridOptions"
          class="ag-theme-material w-100 my-4 ag-grid-table database"
          :columnDefs="columnFaqBbsDefs"
          :defaultColDef="defaultColDef"
          :rowData="faqBbsListCustom"
          rowSelection="single"
          colResizeDefault="shift"
          :animateRows="true"
          :pagination="true"
          :domLayout="domLayout"
          :paginationPageSize="paginationPageSize"
          :suppressPaginationPanel="true"
          :enableRtl="$vs.rtl"
          @rowClicked="onSelectRow"
          @sortChanged="onSortChangedEvent"
          :overlayNoRowsTemplate="noRowsTemplate"
          :detailRowAutoHeight="true"
        >
        </ag-grid-vue>
        <div style="position: relative">
          <!-- ITEMS PER PAGE -->
          <div>
            <div class="flex items-center justify-between">
              <span class="pl-2 mr-2" style="font: 400 13.3333px Arial"
                >{{ totalRows }} 件中 {{ startRow }} 件から
                {{ endRow }} 件までを表示</span
              >
            </div>
          </div>
          <vs-pagination
            :total="totalPages"
            v-model="currentPage"
            :max="5"
            class="pr-10 pt-10"
          />
        </div>
      </div>
    </template>
    <template v-if="creationCompleted && !hasChatSetting">
      <div
        class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center"
        id="page-login"
      >
        <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
          <div slot="no-body" class="full-page-bg-color">
            <div class="vx-row no-gutter justify-center items-center">
              <div class="vx-col sm:w-full md:w-full lg:w-2/3 d-theme-dark-bg">
                <div class="p-8 login-tabs-container">
                  <div class="vx-card__title mb-4">
                    <h4 class="mb-4">ログイン</h4>
                  </div>
                  <form @submit.prevent="chatLogin()">
                    <vs-input
                      name="chatLoginId"
                      icon-no-border
                      icon="icon icon-user"
                      icon-pack="feather"
                      label="ログインID"
                      v-model="chatLoginId"
                      v-validate="'required'"
                      class="w-full"
                      autocomplete="off"
                    />
                    <span style="color: red">{{
                      errors.first("ログインID") | convertError
                    }}</span>

                    <vs-input
                      type="password"
                      name="chatLoginPass"
                      icon-no-border
                      icon="icon icon-lock"
                      icon-pack="feather"
                      label="パスワード"
                      v-model="chatLoginPass"
                      v-validate="'required'"
                      autocomplete="off"
                      class="w-full mt-6"
                    />
                    <span style="color: red">{{
                      errors.first("パスワード") | convertError
                    }}</span>
                    <vs-divider>
                      <vs-input
                        type="submit"
                        value="ログイン"
                        class="login-button"
                      />
                    </vs-divider>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import CellRendererActions from "./CellRendererActions";
import CellRendererTitle from "./CellRendererTitle";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import { AgGridVue } from "ag-grid-vue";
import Conversation from "./Conversation";
import CategoryList from "@/views/chat/CategoryList";
import { createNamespacedHelpers } from "vuex";
import EventBus from "../../EventBus";
import {setupIconClickEvent} from "@/utils/helpler-utils";
import {
  CONTRACT_APP_PAC,
  CONTRACT_APP_PAC2,
  getAppEnvText,
  getContractAppText,
  getContractServerText,
} from "../../utils/bbsUtils";
import { faqState } from "../../enums/faqBbs";

const faqBbsModule = createNamespacedHelpers("faqBbs");
const chatSettingModule = createNamespacedHelpers("chatSetting");

export default {
  components: {
    AgGridVue,
    CellRendererActions,
    CellRendererTitle,
    Conversation,
    CategoryList,
  },
  data() {
    return {
      iconVsInput:'close',
      //Pagination
      paginationPageSize: 10,
      pageNumber: 1,
      startRow: 0,
      endRow: 0,

      // AgGrid
      noRowsTemplate: "<span>データがありません</span>",
      domLayout: "autoHeight",
      gridOptions: {
        onGridSizeChanged: () => {
          if (this.gridApi) this.gridApi.sizeColumnsToFit();
        },
      },
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true,
        wrapText: true,
        autoHeight: true,
        sortingOrder: ["asc", "desc"],
      },
      columnFaqBbsDefs: [
        {
          headerName: "カテゴリ",
          field: "category_name",
          filter: true,
          width: 190,
          unSortIcon: true,
          suppressMovable: true,
        },
        {
          headerName: "タイトル",
          field: "title",
          filter: true,
          width: 170,
          unSortIcon: true,
          cellRendererFramework: "CellRendererTitle",
          suppressMovable: true,
        },
        {
          headerName: "投稿ユーザ",
          field: "fullname",
          filter: true,
          width: 160,
          unSortIcon: true,
          suppressMovable: true,
        },
        {
          headerName: "所属企業",
          field: "company_name",
          filter: true,
          width: 170,
          unSortIcon: true,
          suppressMovable: true,
        },
        {
          headerName: "契約ｱﾌﾟﾘｹｰｼｮﾝ",
          field: "contract_app",
          filter: true,
          width: 140,
          unSortIcon: true,
          suppressMovable: true,
        },
        {
          headerName: "契約環境",
          field: "app_env",
          filter: true,
          width: 190,
          unSortIcon: true,
          suppressMovable: true,
        },
        {
          headerName: "契約サーバー",
          field: "contract_server",
          filter: true,
          width: 190,
          unSortIcon: true,
          suppressMovable: true,
        },
        {
          headerName: "登録日時",
          field: "created_at",
          filter: true,
          width: 190,
          unSortIcon: true,
          suppressMovable: true,
        },
        {
          headerName: "更新者",
          field: "last_update_user_name",
          filter: true,
          width: 190,
          unSortIcon: true,
          suppressMovable: true,
        },
        {
          headerName: "更新日時",
          field: "updated_at",
          filter: true,
          width: 190,
          unSortIcon: true,
          suppressMovable: true,
        },
        {
          headerName: "",
          field: "transactions",
          width: 130,
          cellRendererFramework: "CellRendererActions",
          unSortIcon: false,
          suppressMovable: true,
        },
      ],

      // Cell Renderer Components
      components: {
        CellRendererActions,
        CellRendererTitle,
      },
      conversationPopup: false,
      bbsDialogPopup: false,
      boxChat: false,
      filterChats: {
        email: "",
        user_name: "",
        company: "",
        contract_app: "",
        app_env: "",
        contract_server: null,
        category_id: null,
        is_new: null,
        state: null,
        charge_admin_id: null,
      },
      contractApps: [
        { key: "", value: "..." },
        { key: CONTRACT_APP_PAC, value: "PAC" },
        { key: CONTRACT_APP_PAC2, value: "PAC 2" },
      ],
      contractServers: [
        { key: null, value: "..." },
        { key: 0, value: "1 号機" },
      ],
      appEnvs: [
        { key: "", value: "..." },
        { key: 0, value: "AWS" },
        { key: 1, value: "K5" },
      ],

      paginationOptions: [10, 20, 30, 50],
      selectedItem: null,
      selectedId: null,
      isShowDetail: false,
      hasChatSetting: false,
      chatLoginId: "",
      chatLoginPass: "",
      creationCompleted: false,
      sentEvent: false,
    };
  },
  watch: {
    paginationPageSize(val) {
      this.setPagination(val);
    },
  },
  computed: {
    ...faqBbsModule.mapState(["chargeAdminList"]),
    ...faqBbsModule.mapGetters([
      "faqBbsList",
      "faqBbsCategoryList",
      "totalPages",
      "totalRows",
      "getFaqBbsCategoryList",
    ]),
    gridApi() {
      return this.gridOptions.api;
    },
    currentPage: {
      get() {
        return this.$store.state.faqBbs.faqBbsListModel
          ? this.$store.state.faqBbs.faqBbsListModel.current_page || 1
          : 1;
      },
      async set(val) {
        this.pageNumber = val;
        if (this.hasChatSetting) {
          await this.fetchFaqBbsList({
            ...this.filterChats,
            page: val,
            limit: this.paginationPageSize,
          });
        }
        //if(this.gridApi) this.gridApi.paginationGoToPage(val-1)
        //this.SET_BBS_LIST_CURRENT_PAGE(val)
      },
    },
    faqBbsListCustom() {
      if (!this.faqBbsList) return [];
      return this.faqBbsList.map((item) => {
        const new_item = Object.assign(
          { ...item },
          {
            contract_app: getContractAppText(item.contract_app),
            app_env: getAppEnvText(item.app_env),
            contract_server: getContractServerText(item.contract_server),
          }
        );
        return new_item;
      });
    },
    faqStateOptions() {
      return [{ value: null, text: "..." }, ...faqState];
    },
    chargeAdminOptions() {
      return [{ id: null, name: "..." }, ...this.chargeAdminList];
    },
    appActiveUser() {
      return this.$store.state.AppActiveUser;
    },
    categoryStateOptions() {
      const options = [{ key: null, value: "..." }];

      if (this.getFaqBbsCategoryList && Array.isArray(this.getFaqBbsCategoryList)) {
        this.getFaqBbsCategoryList.forEach(item => {
            const exists = options.some(option => option.key === item.id);
            if (!exists) {
                options.push({ key: item.id, value: item.name });
            }
        });
      }
      
      options.sort((a, b) => a.key - b.key);
      return options;
    },
  },
  methods: {
    ...faqBbsModule.mapActions([
      "fetchFaqBbsList",
      "fetchFaqBbsCommentList",
      "getFaqBbs",
      "countUnreadFaqBbs",
      "fetchChargeAdmins",
      "fetchFaqBbsCategoryList",
    ]),
    ...faqBbsModule.mapMutations(["SET_BBS_LIST_CURRENT_PAGE"]),
    ...chatSettingModule.mapActions([
      "checkChatSetting",
      "storeChatSetting",
      "removeChatSetting",
      "updateUserSeting",
    ]),
    clearInput(modelExpression) {
      // Clear the value input
      if (modelExpression.startsWith('filterChats.')) {
        const property = modelExpression.substring('filterChats.'.length);
        this.$set(this.filterChats, property, '');
      }
    },
    async resetColFilters() {
      // Reset Grid Filter
      if (this.gridApi) {
        this.gridApi.setFilterModel(null);
        this.gridApi.onFilterChanged();
      }
      this.filterChat = null;
      this.ids = [];
      await this.searchWithOrder();
      await this.fetchFaqBbsCategoryList();
      this.$refs.filterCard.removeRefreshAnimation();
    },
    async searchWithOrder() {
      await this.fetchFaqBbsList({
        ...this.filterChats,
        page: this.pageNumber,
        limit: this.paginationPageSize,
      });
    },
    async onSelectRow() {
      if (!this.gridApi) return;
      if (this.isShowDetail) return;
      const row = this.gridApi.getSelectedRows().shift();
      if (!row) return;
      this.selectedId = row.id;
      this.selectedItem = await this.getFaqBbs(row.id);
      if (!this.selectedItem) return;
      this.selectedItem.author_type = row.author_type;
      if (!row.author_type) {
        const res = await this.fetchFaqBbsCommentList(row.id);
        if (!res) return;
      }
      this.showConversation();
    },
    onSortChangedEvent(event) {
      let columns = event.columnApi.getAllColumns();
      let root = this;
      columns.forEach(function (column) {
        if (column.getSort()) {
          root.orderDir = column.getSort();
          root.orderBy = column.getColId();
        }
      });
    },
    showConversation() {
      this.conversationPopup = true;
    },
    async onCloseConversationPopup() {
      this.conversationPopup = false;
      if (this.sentEvent) {
        await this.searchWithOrder();
      }
      this.sentEvent = false;
    },
    deleteFaqBbsNewIcon() {
      this.onCloseConversationPopup();
      this.searchWithOrder();
    },
    async setPagination(val) {
      if (this.gridApi) this.gridApi.paginationSetPageSize(val);
      this.pageNumber = 1;
      // await this.fetchFaqBbsList({page: 1, limit: val})
    },
    chatLogin() {
      this.$validator.validateAll().then(async (result) => {
        if (result) {
          let chatSetting = {
            chat_login_id: this.chatLoginId,
            chat_login_pass: this.chatLoginPass,
          };
          this.hasChatSetting = await this.storeChatSetting(chatSetting);
          if (this.hasChatSetting) {
          let activeUser = {
            ...this.appActiveUser,
            user_setting: {
              ...this.appActiveUser.user_setting,
              chat_login_id: chatSetting.chat_login_id,
              chat_login_pass: chatSetting.chat_login_pass,
            },
          };
            this.updateUserSeting(activeUser)
            this.countUnreadFaqBbs();
            this.fetchChargeAdmins();
            this.fetchFaqBbsCategoryList();
          }
        }
      });
    },
    async chatLogout() {
      await this.removeChatSetting();
      let activeUser = {
            ...this.appActiveUser,
            user_setting: {
              ...this.appActiveUser.user_setting,
              chat_login_id: null,
              chat_login_pass: null,
            },
          };
          this.updateUserSeting(activeUser)
      this.hasChatSetting = false;
      this.$store.commit("faqBbs/SET_UNREAD_FAQ_BBS", 0);
      this.$store.commit("SET_FAQ_BBS_LIST_MODEL", []);
      this.$store.commit("faqBbs/SET_FAQ_BBS_CATEGORY_LIST_MODEL", []);
    },
  },
  async created() {
    this.hasChatSetting = await this.checkChatSetting();
    if (
      this.appActiveUser.enable_chat &&
      this.appActiveUser.user_setting.chat_login_id &&
      this.appActiveUser.user_setting.chat_login_pass
    ) {
      this.fetchChargeAdmins();
    }
    this.fetchFaqBbsCategoryList();
    // await this.fetchFaqBbsList({...this.filterChats, page: this.pageNumber, limit: this.paginationPageSize})
    this.creationCompleted = true;
  },
  beforeMount() {
    // set page after load (change route = 10, refresh = save PaginationSize in SessionStorage )
    let paginationPageSize = sessionStorage.getItem("paginationPageSize");
    if (paginationPageSize !== null)
      this.paginationPageSize = paginationPageSize;
  },
  mounted() {
    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector(
        ".ag-header-container"
      );
      header.style.left = `-${String(
        Number(header.style.transform.slice(11, -3)) + 9
      )}px`;
    }

    EventBus.$on("showRecord", (id) => {
      this.isShowDetail = true;
      this.$router.push(`/chat/list/${id}`);
    });

    // save paginationSize to sessionStorage (when fresh browser)
    const root = this;
    window.addEventListener("beforeunload", function () {
      sessionStorage.setItem("paginationPageSize", root.paginationPageSize);
    });
    setupIconClickEvent();
  },
  updated() {
    // calc number startRow and endRow
    this.$nextTick(() => {
      if (!this.$store.state.loading && this.faqBbsList.length > 0) {
        this.startRow =
          this.pageNumber * this.paginationPageSize -
          this.paginationPageSize +
          1;
        if (this.faqBbsList.length === this.paginationPageSize)
          this.endRow = this.pageNumber * this.paginationPageSize;
        else
          this.endRow =
            this.paginationPageSize * this.pageNumber +
            this.faqBbsList.length -
            this.paginationPageSize;
      }
      if (this.faqBbsList.length === 0) {
        this.endRow = 0;
        this.startRow = 0;
      }
    });
  },
  beforeDestroy() {
    EventBus.$off("showRecord");
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/vuexy/components/view/faq-bbs.scss";
.vs-con-input .icon-after {
  right: 7px;
  top: 10px;
  border: none;
  cursor: pointer;
}
</style>
